import React from 'react';
import { Create, SelectArrayInput, SelectInput, SimpleForm, TextInput, required } from 'react-admin';
import { roleChoices } from '../../Services/users';
import { countryChoices } from '../../Services/countries';

export const UserCreate = (props:any) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="firstname" />
      <TextInput source="lastname" />
      <TextInput source="email" />
      <TextInput source="phone" />
      <SelectInput
        source="country"
        choices={countryChoices}
        optionText="name"
        optionValue="id"
        validate={required()}
      />
      <SelectArrayInput
          source="roles"
          choices={roleChoices}
          optionText="name"
          optionValue="id"
        />
    </SimpleForm>
  </Create>
);